import React, { ForwardRefExoticComponent, RefAttributes } from 'react';
import { Flex, Icon, FlexProps, Text, Tooltip } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import { IconProps } from 'phosphor-react';

interface NavItemProps extends FlexProps {
  icon: ForwardRefExoticComponent<IconProps & RefAttributes<SVGSVGElement>>;
  href: string;
  onClick?: () => void;
  children: string;
  openMenu: boolean;
}

export function NavItem({ icon, href, onClick, children, openMenu, ...rest }: NavItemProps) {
  const { pathname } = useLocation();
  const ativo = pathname === href || pathname.includes(`${href}/`);

  return (
    <Tooltip label={children} placement="right" hasArrow isDisabled={openMenu}>
      <Flex
        w="full"
        h="40px"
        my="2px"
        px={openMenu ? 3 : 0}
        gap={3}
        align="center"
        justify={openMenu ? 'flex-start' : 'center'}
        borderRadius="12px"
        cursor="pointer"
        bg={ativo ? '#EAF4FF' : 'transparent'}
        color={ativo ? '#1B88F5' : '#475569'}
        transition="background 0.18s ease, color 0.18s ease"
        _hover={{ bg: ativo ? '#E1EFFF' : '#F5F8FB', color: ativo ? '#1B88F5' : '#0F172A' }}
        onClick={() => (onClick ? onClick() : undefined)}
        {...rest}
      >
        {icon && <Icon w="20px" h="20px" flexShrink={0} as={icon} />}
        {openMenu && (
          <Text
            fontFamily="heading"
            fontWeight={ativo ? 700 : 500}
            fontSize="13.5px"
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
            title={children}
          >
            {children}
          </Text>
        )}
      </Flex>
    </Tooltip>
  );
}
